import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '../components/common/Layout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import Dashboard from '../pages/Dashboard';
import Expenses from '../pages/Expenses';
import Invoices from '../pages/Invoices';
import Projects from '../pages/Projects';
import ProjectDetailPage from '../pages/ProjectDetailPage';
import ProjectFormPage from '../pages/ProjectFormPage';
import Reports from '../pages/Reports';
import Categories from '../pages/Categories';
import Users from '../pages/Users';
import Assets from '../pages/Assets';
import MyCompany from '../pages/MyCompany';
import AdminCompanies from '../pages/admin/Companies';
import GlobalDashboard from '../pages/admin/GlobalDashboard';
import AdminUsers from '../pages/admin/AdminUsers';
import CompanyDashboard from '../pages/admin/CompanyDashboard';
import LogsSearch from '../pages/admin/LogsSearch';
import AdminReports from '../pages/admin/AdminReports';
import Login from '../pages/Login';
import Profile from '../pages/Profile';
import Help from '../pages/Help';
import Privacy from '../pages/Privacy';
import ThemePrototype from '../pages/ThemePrototype';
import Branding from '../pages/Branding';
import Clients from '../pages/Clients';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'expenses',
        element: <Expenses />,
      },
      {
        path: 'invoices',
        element: <Invoices />,
      },
      {
        path: 'projects',
        element: <Projects />,
      },
      {
        path: 'clients',
        element: <Clients />,
      },
      {
        path: 'projects/new',
        element: (
          <ProtectedRoute requiredRole="admin">
            <ProjectFormPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'projects/:projectId/edit',
        element: (
          <ProtectedRoute requiredRole="admin">
            <ProjectFormPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'projects/:projectId',
        element: <ProjectDetailPage />,
      },
      {
        path: 'reports',
        element: <Reports />,
      },
      {
        path: 'categories',
        element: (
          <ProtectedRoute requiredRole="admin">
            <Categories />
          </ProtectedRoute>
        ),
      },
      {
        path: 'my-company',
        element: (
          <ProtectedRoute requiredRole="admin">
            <MyCompany />
          </ProtectedRoute>
        ),
      },
      {
        path: 'users',
        element: (
          <ProtectedRoute requiredRole="admin">
            <Users />
          </ProtectedRoute>
        ),
      },
      {
        path: 'assets',
        element: (
          <ProtectedRoute requiredRole="admin">
            <Assets />
          </ProtectedRoute>
        ),
      },
      {
        path: 'branding',
        element: (
          <ProtectedRoute requiredRole="admin">
            <Branding />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/dashboard',
        element: (
          <ProtectedRoute requiredRole="superadmin">
            <GlobalDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/companies',
        element: (
          <ProtectedRoute requiredRole="superadmin">
            <AdminCompanies />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/users',
        element: (
          <ProtectedRoute requiredRole="superadmin">
            <AdminUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/reports',
        element: (
          <ProtectedRoute requiredRole="superadmin">
            <AdminReports />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/logs',
        element: (
          <ProtectedRoute requiredRole="superadmin">
            <LogsSearch />
          </ProtectedRoute>
        ),
      },
      {
        path: 'companies/:companyId',
        element: (
          <ProtectedRoute requiredRole="superadmin">
            <CompanyDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: 'help',
        element: <Help />,
      },
      {
        path: 'privacy',
        element: <Privacy />,
      },
    ],
  },
  {
    path: '/theme-prototype',
    element: <ThemePrototype />,
  },
]);
